import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { URL } from '../../constants/url'
import { RootState } from '../../../states/containers/store'
import Loading from '../../components/common/Loading'

import {
  createMicrosoftLink,
} from '../../../states/containers/setting/microsoftSyncSlice'
import { setPath } from '../../../utils/url'

const MicrosoftCallback: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    commonPart,
    login,
  } = useSelector((state: RootState) => (state))

  useEffect(() => {
    if (!login.accessToken) return
    const urlStr = location.href
    const callbackUrl = { callback_url: urlStr }
    dispatch(createMicrosoftLink(callbackUrl,
      (result) => {
        history.push({ pathname: setPath(URL.SETTING_OAUTH.path, commonPart.language as string), state: result })
      },
      () => {
        history.push(`${setPath(URL.SETTING_OAUTH.path, commonPart.language as string)}?account_setting_error=microsoft`)
      }))
  }, [login.accessToken])

  return (
    <>
      <Loading />
    </>
  )
}

export default MicrosoftCallback
